<template>
  <div>
    <vmodal
      name="uploadImageModal"
      :minWidth="1000"
      :minHeight="700"
      :adaptive="true"
    >
      <div class="images-modal">
        <div class="category-top-bar location-group-form-modal" ref="optionsTopBar">
          <div class="upload-modal-header">
            <p>
              <a class="btn btn-icon btn-danger mar-rt-10" :title="$t('settingsPages.locationGroupsDelete')" @click.prevent="closeModal()"><i class="ti-close"></i></a>
            </p>
          </div>
        </div>
        <div class="modal-container">
          <div class="row height-200">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('upload.browse') }}</label>
                <el-upload
                  action=""
                  ref="upload"
                  :limit="2"
                  :file-list="imagelist"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png"
                  :on-change="handleImgChnage"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                  :auto-upload="false">
                  <i class="el-icon-plus"></i>
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize2MB')}}</div>
                </el-upload>
                <!-- <button 
                  class="btn btn-purple mar-to-10 mar-bt-10 generate-code" 
                  @click.prevent="uploadImage()"
                >Upload</button> -->
              </div>
            </div>
            <div class="col-md-12 choose-image">
              <label>{{ $t('marketingCampaigns.chooseImage') }}</label>
            </div>
          </div>
          <div>
            <div class="productlist">
              <template v-for="image in images">
                <div class="product" @click="selectImage(image)">
                  <div class="product_img_title">
                    <template v-if="image.filename">
                      <div class="productImage" :style="'background: url(' + image.filename + ');'">
                        <a class="btn btn-danger active btn-icon margin-7" @click.stop="deleteImage(image.id)">
                          <i class="ti-close"></i>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <!-- <img v-for="image in images" width="150px" height="150px" @click="selectImage(image)" :style="'background: url(' + image.filename + ');'" :key="image.id" alt=""> -->
            </div>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>
<script>
import swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.css'

export default {
  components: {
  },
  data () {
    return {
      imagelist: [],
      url: null,
      images: []
    }
  },
  created () {
    this.getData()
  },
  props: {
    handleModal: {
      required: false,
      type: Boolean
    }
  },
  watch: {
    handleModal (value) {
      if (value) {
        this.$modal.show('uploadImageModal')
      } else {
        this.$modal.hide('uploadImageModal')
      }
    }
  },
  methods: {
    deleteImage (id) {
      let requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        id: id
      }
      this.apiRequest('/campaign-images/' + id, 'DELETE', requestData, (response) => {
        if (response.status) {
          this.images = response.data
        }
      })
    },
    selectImage (image) {
      this.$emit('selected-image', image.filename)
      this.closeModal()
    },
    open () {
      this.$modal.show('uploadImageModal')
      this.$emit('open')
    },
    closeModal () {
      this.$modal.hide('uploadImageModal')
    },
    getData () {
      let requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/campaign-images', 'GET', requestData, (response) => {
        if (response.status) {
          this.images = response.data
        }
      })
    },
    uploadImage () {
      let requestData = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (this.imagelist && this.imagelist[0].status === 'ready') {
        this.getBase64(this.imagelist[0].raw).then(
          (base64enc) => {
            requestData.image = base64enc
            this.apiRequest('/campaign-images', 'POST', requestData, (response) => {
              if (response.status) {
                this.imagelist = []
                this.images = response.data
              }
            })
          }
        )
      }
    },
    handleImgChnage (file, fileList) {
      // console.warn('handleImgChnage')
      // const isJPG = file.type === 'image/jpeg'
      const isOkSize = file.size / 1024 / 1024 < 5
      if (!isOkSize) {
        swal({
          toast: true,
          type: 'warning',
          text: this.$t('validations.pictureSizeExceed2MB'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
        this.$refs.upload.clearFiles()
        this.imagelist = []
      } else {
        if (fileList.length > 1) {
          this.imagelist = fileList.slice(1)
        } else {
          this.imagelist = fileList
        }
        this.uploadImage()
      }
    },
    handleRemove (file, fileList) {
      if (fileList.length === 0) {
        this.imagelist = []
      }
    },
    handleExceed (files, fileList) {
      swal({
        text: this.$t('validations.removePhoto'),
        type: 'warning',
        showConfirmButton: true
      })
    },
    beforeUpload (file) {
      const isOkSize = file.size / 1024 / 1024 < 5
      if (!isOkSize) {
        swal({
          toast: true,
          type: 'warning',
          title: this.$t('validations.pictureSizeExceed'),
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        })
      }
      return isOkSize
    }
  }
}
</script>
<style scoped lang="scss">
  .location-group-form-modal {
    background: #F4F6FF !important;
    padding: 15px 15px 5px 15px !important;
    margin: 0 !important;
    height: 65px;
  }

  .upload-modal-header {
    display: flex;
    align-content: stretch;
    flex-direction: row;
    justify-content: flex-end;
  }
  .images-modal {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .modal-container {
    padding: 20px;
    height: calc(100% - 65px);
    position: relative;
  }

  .height-200 {
    height: 200px;
  }

  .choose-image {
    width: auto;
    clear: both;
  }

  .images-container {
    height: calc(100% - 200px);
    overflow: auto;
  }

  .productlist {
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
  }

  .productImage {
    height: 200px;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  .product {
    width: calc(20% - 20px);
    margin-bottom: 20px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .margin-7 {
    margin: 7px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/UploadImageModal.vue